import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
    AtualizarPerfilFinanceiroController,
    CadastrarPerfilFinanceiroController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/PerfilFinanceiro/PerfilFinanceiroController";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import { IPerfilFinanceiro } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/PerfilFinanceiro/PerfilFinanceiroInterface";
import IconSelector from "../../../../../../CardsPages/Forms/IconSelector";
import UnForm from "../../../../../../Form";
import { useFormContext } from "react-hook-form";

interface ICadastroPerfilFinanceiroProps {
    editando: boolean;
    updateList: () => void;
    rowPerfil?: IPerfilFinanceiro;
}

interface IFormData {
    DS_PERFIL_FINANCEIRO_CONTA: string;
    HX_COR_PERFIL_FINANCEIRO_CONTA: string;
    DS_ICON_PERFIL_FINANCEIRO_CONTA: string;
    FL_ATIVO: boolean;
}

export default function CadastroPerfilFinanceiro(
    props: ICadastroPerfilFinanceiroProps
) {
    const FormMethods = useForm();

    const {
        execute: cadastrarPerfilFinanceiro,
        loading: cadastrarPerfilFinanceiroLoading,
    } = useAsyncCallback(CadastrarPerfilFinanceiroController);

    const [icon, setIcon] = useState(
        props.rowPerfil?.DS_ICON_PERFIL_FINANCEIRO_CONTA ?? ""
    );

    const {
        execute: atualizarPerfilFinanceiro,
        loading: atualizarPerfilFinanceiroLoading,
    } = useAsyncCallback(AtualizarPerfilFinanceiroController);

    function handleCadastrarPerfilFinanceiro(formData: IFormData) {
        if (!props.rowPerfil?.ID_PERFIL_FINANCEIRO_CONTA) {
            cadastrarPerfilFinanceiro({
                ...formData,
                DS_ICON_PERFIL_FINANCEIRO_CONTA: icon,
            }).then(() => {
                props.updateList();
            });
        } else {
            atualizarPerfilFinanceiro({
                ...formData,
                DS_ICON_PERFIL_FINANCEIRO_CONTA: icon,
                ID_PERFIL_FINANCEIRO_CONTA:
                    props.rowPerfil.ID_PERFIL_FINANCEIRO_CONTA,
            }).then(() => {
                props.updateList();
            });
        }
    }

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={handleCadastrarPerfilFinanceiro}
                className="row"
            >
                <div className="form-group col-12 ">
                    <UnForm.Input
                        type="text"
                        name="DS_PERFIL_FINANCEIRO_CONTA"
                        label="Perfil Financeiro"
                        defaultValue={
                            props.rowPerfil?.DS_PERFIL_FINANCEIRO_CONTA
                        }
                        registerOptions={{
                            required: "Insira o nome do perfil financeiro",
                        }}
                    />
                </div>

                <UnForm.Input
                    name="HX_COR_PERFIL_FINANCEIRO_CONTA"
                    type="color"
                    label="Cor"
                    wrapperClassName="col-12 col-md-3 col-lg-2 my-2"
                    defaultValue={
                        props.rowPerfil?.HX_COR_PERFIL_FINANCEIRO_CONTA ?? "#000000"
                    }
                />

                <IconSelectorWithFormColor
                    onChange={setIcon}
                    defaultValue={props.rowPerfil?.DS_ICON_PERFIL_FINANCEIRO_CONTA}
                    defaultColor={props.rowPerfil?.HX_COR_PERFIL_FINANCEIRO_CONTA}
                />
                <div className="form-group col-12 ">
                    <UnForm.Switch
                        color="primary"
                        type="checkbox"
                        name="FL_ATIVO"
                        label="Ativo"
                        defaultChecked={props.rowPerfil?.FL_ATIVO}
                    />
                </div>
                <div className="col-12">
                    <UnForm.SubmitButton
                        outline
                        color="success"
                        iconSize="lg"
                        loading={
                            cadastrarPerfilFinanceiroLoading ||
                            atualizarPerfilFinanceiroLoading
                        }
                        wrapperClassName="col-12 m-0 p-0"
                        className="d-none font-weight-bold col-12"
                        icon={faPaperPlane}
                    >
                        {!props.editando
                            ? "Cadastrar Perfil Financeiro"
                            : "Editar Perfil Financeiro"}
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </FormProvider>
    );
}

function IconSelectorWithFormColor(
    props: Omit<Parameters<typeof IconSelector>["0"], "color"> & {
        defaultColor?: string;
    }
) {
    const { watch } = useFormContext();
    const colorWatcher = watch("HX_COR_CLIENTE", props.defaultColor);

    return <IconSelector color={colorWatcher} {...props} />;
}
